import {equals} from 'ramda';

import {PromoPhotosFormType} from '../types/PromoPhotosFormType';
import {PromoPhotosType} from '../types/PromoPhotosType';
import {getPromoPhotoDefaultValues} from './getPromoPhotoDefaultValues';
import {getPromoPhotoRequestData} from './getPromoPhotoRequestData';

// Compares request bodies so form-only representation details (upload url, index defaults) do
// not count as changes.
export const dataChanged = (editData: PromoPhotosType, data: PromoPhotosFormType) =>
  equals(
    getPromoPhotoRequestData(getPromoPhotoDefaultValues(editData)),
    getPromoPhotoRequestData(data)
  );
